<template>
  <div class="wg-row">
    <div class="wg-row" style="justify-content:space-between;margin-bottom:20px;">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Orders list', 'Lista ordini')"
          @click="$router.push('/orders')"
      >
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Export CSV', 'Esporta CSV')"
          @click="exportToCsv"
      >
    </div>
    <div v-if="chartData.length == 0" class="wg-row">
      <div class="com-anm22-app-text-xxl">
        {{ $anm22.strLang(lang, 'No products sold', 'Nessun prodotto venduto') }}
      </div>
    </div>
    <div
        v-else
        v-for="(c,index) in chartData"
        :key="'chart-'+index"
        class="wg-row com-anm22-food-chart-ext">
      <div 
          :id="'chart-cat-' + c.category.id"
          class="com-anm22-food-chart-int" 
          style="overflow-x:auto;min-height:500px;height:20px;"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    timezone: {
      type: String, 
      default: "Europe/Rome"
    },
    data: {
      type: Object,
      default: () => ({})
    },
    from: String,
    to: String
  },
  data() {
    return {
      chartData: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    start() {
      return this.$moment.tz(this.from, this.timezone);
    },
    end() {
      return this.$moment.tz(this.to, this.timezone);
    },
  },
  methods: {
    drawCharts() {
      this.chartData.forEach(catData => {

        const data = new window.google.visualization.DataTable();
        data.addColumn('string', '');
        data.addColumn('number', this.$anm22.strLang(this.lang, "Sold", "Venduti"));
  
        catData.products.forEach(prodData => {
          data.addRow([prodData.name.replace(/'/g, "\\'"), Number(prodData.qnt)]);
        });
        if(catData.products.length <= 10) {
          for(let i = catData.products.length; i <= 10; i++) {
            data.addRow([' ', 0]);
          }
        }

        data.sort({column: 1, desc: true});

        const options = {
          chart: {
            title: catData.category.name.replace(/'/g, "\\'")
          },
          titleTextStyle: {
            fontSize: 18
          },
          backgroundColor: {
            fill: '#fff'
          },
          series: {
            0: { color: '#40C4FF' }
          },
          legend: {
            position: 'none'
          },
          animation: {
            startup: true,
            duration: 1000,
            easing: 'out'
          },
          bars: 'horizontal',
          isStacked: true
        };
  
        const chart = new window.google.charts.Bar(document.getElementById('chart-cat-' + catData.category.id));
        chart.draw(data, window.google.charts.Bar.convertOptions(options));
      });
    },
    exportToCsv() {
      const rows = [];
      // Header
      const header = [
        this.$anm22.strLang(this.lang, 'Name', 'Nome'),
        this.$anm22.strLang(this.lang, 'Category', 'Categoria'),
        this.$anm22.strLang(this.lang, 'Sold', 'Venduti')
      ];
      rows.push(header);

      this.chartData.forEach(catData => {
        catData.products.forEach(prodData => {
          rows.push([
            prodData.name.replace(/'/g, "\\'"),
            catData.category.name.replace(/'/g, "\\'"),
            Number(prodData.qnt)
          ]);
        });
      });

      let csvContent = "data:text/csv;charset=utf-8,";
      rows.forEach(row => {
        csvContent += row.join(';') + '\n';
      })

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "yf_products_" + this.start.format('DD-MM-YY') + '_' + this.end.format('DD-MM-YY') + ".csv");
      link.click();
    }
  },
  created() {
    // Elaborazione dati da inserire nei grafici
    // const charts = [];
    // this.data.categories.forEach(c => {
    //   charts.push({
    //     category: c,
    //     products: []
    //   });
    // });
    // this.data.orderElements.forEach(e => {
    //   const product = this.data.products.find(p => e.product === p.id);
    //   const catChart = charts.find(c => c.category.id === product.category);
    //   if(catChart) {
    //     const prodData = catChart.products.find(p => p.product.id === product.id);
    //     if(prodData) {
    //       prodData.qnt++;
    //     } else {
    //       catChart.products.push({
    //         product: product,
    //         name: e.productName,
    //         qnt: 1
    //       });
    //     }
    //   }
    // });
    this.chartData = this.data.charts.products;
  },
  mounted() {
    // Creazione grafici
    window.google.charts.load('current', {packages: ['corechart', 'bar']});
    window.google.charts.setOnLoadCallback(this.drawCharts);
  },
  watch: {
    windowWidth(newVal, old) {
      this.drawCharts();
    },
    windowHeight(newVal, old) {
      this.drawCharts();
    }
  }
}
</script>

<style lang="scss" scoped>

</style>